import { render, staticRenderFns } from "./Create2.vue?vue&type=template&id=408614d0&scoped=true&"
import script from "./Create2.vue?vue&type=script&lang=js&"
export * from "./Create2.vue?vue&type=script&lang=js&"
import style0 from "./Create2.vue?vue&type=style&index=0&id=408614d0&prod&lang=css&"
import style1 from "./Create2.vue?vue&type=style&index=1&id=408614d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408614d0",
  null
  
)

export default component.exports